import CountUp from "react-countup";
import axios from "axios"
import { useUser } from "../../../providers/UserContext"
import ButtonsMap from "../../../Components/ComponentsMarketplace/ButtonsMap";
import HeaderReportMp from "../../../Components/ComponentsMarketplace/HeaderReportMp";

import {
  Container,
  SizeContainer,
  PelImg,
  ContainerReport,
  ParagraphValue,
  ParagraphValuePositive,
  NoteFooter,
} from "./style";
import { useEffect, useState } from "react";
import Loading from "../../../Components/Loading";

const LossesAndProfits = () => {
  const aluguel = 90000
  const [loading, setLoading] = useState(false)
  const { marketPlace, jogo } = useUser()
  const [profitsAndLosses, setProfitsAndLosses] = useState({})

  useEffect(() => {
    if (!marketPlace?.supermercado || !jogo?.jogo) return
    fetchLosses()
  }, [jogo, marketPlace])

  const fetchLosses = async () => {
    try {
      setLoading(true)
      const response = await axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/lucroseperdas/obterSupermercadoJogo/${marketPlace?.supermercado}/${jogo?.jogo}`)
      let custos = 0
      let data = {
        receita: 0,
        cmv: 0,
        outros: 0,
        custos: 0,
        impostos: 0,
        margemBruta: 0,
        lucroLiquido: 0
      }

      response.data?.forEach(item => {
        if (item.tipo === "VENDA_SUPERMERCADO") {
          data.receita += item.total
        } else if (item.tipo === "COMPRA_SUPERMERCADO") {
          data.custos += Math.abs(item.total)
          data.cmv = Math.abs(item.total)
        } else if (item.tipo === "OUTROS") {
          data.custos += Math.abs(item.total)
          data.outros += Math.abs(item.total)
        }
      })

      data.impostos = (10 / 100) * data.receita
      data.custos += data.impostos
      data.margemBruta += (data.receita - data.custos)
      data.lucroLiquido += (data.margemBruta - aluguel)
      setProfitsAndLosses(data)
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false)
    }
  }


  return (
    <Container>
      <SizeContainer>
        <HeaderReportMp
          title="Lucros e Perdas"
          pathImg="./images/pel_button.svg"
        />
        <PelImg src="./images/pel_img.svg" />

        <ContainerReport>
          {loading ? (
            <Loading />
          ) : (
            <>
              <ParagraphValuePositive>
                <span>
                  Receitas
                </span>
                <span>
                  <CountUp
                    prefix="+ R$"
                    end={profitsAndLosses?.receita}
                    separator="."
                    decimal=","
                    decimals={2}
                    duration={0.5}
                  />
                </span>
              </ParagraphValuePositive>

              <ParagraphValue>
                <span>
                  Impostos
                </span>
                <span>
                  <CountUp
                    prefix="- R$ "
                    end={profitsAndLosses?.impostos}
                    separator="."
                    decimal=","
                    decimals={2}
                    duration={0.5}
                  />
                </span>
              </ParagraphValue>

              <ParagraphValue>
                <span>
                  CMV (Custo da Mercadoria Vendida)
                </span>
                <span>
                  <CountUp
                    prefix="- R$"
                    end={profitsAndLosses?.cmv}
                    separator="."
                    decimal=","
                    decimals={2}
                    duration={0.5}
                  />
                </span>
              </ParagraphValue>

              <ParagraphValue style={{ color: profitsAndLosses?.margemBruta < 0 ? "red" : "#222" }}>
                <span>
                  Margem Bruta
                </span>
                <span>
                  <CountUp
                    prefix="R$"
                    end={profitsAndLosses?.margemBruta}
                    separator="."
                    decimal=","
                    decimals={2}
                    duration={0.5}
                  />
                </span>
              </ParagraphValue>

              <ParagraphValue>
                <span>
                  Aluguel
                </span>
                <span>
                  <CountUp
                    prefix="- R$"
                    end={aluguel}
                    separator="."
                    decimal=","
                    decimals={2}
                    duration={0.5}
                  />
                </span>
              </ParagraphValue>

              <ParagraphValue>
                <span>
                  Outros
                </span>
                <span>
                  <CountUp
                    prefix="- R$"
                    end={profitsAndLosses?.outros}
                    separator="."
                    decimal=","
                    decimals={2}
                    duration={0.5}
                  />
                </span>
              </ParagraphValue>

              <ParagraphValue style={{ color: profitsAndLosses?.lucroLiquido < 0 ? "red" : "#222" }}>
                <span>
                  Lucro/Prejuízo
                </span>
                <span>
                  <CountUp
                    prefix="R$"
                    end={profitsAndLosses?.lucroLiquido}
                    separator="."
                    decimal=","
                    decimals={2}
                    duration={0.5}
                  />
                </span>
              </ParagraphValue>
            </>

          )
          }

        </ContainerReport>
        <NoteFooter>
          <p>Ponto de Equilibrio</p>
          <span style={{ color: profitsAndLosses?.lucroLiquido >= 0 ? "" : "red" }}>
            <CountUp
              prefix="R$"
              end={((profitsAndLosses?.margemBruta / profitsAndLosses.receita) * 100)}
              separator="."
              decimal=","
              decimals={2}
              duration={0.5}
            />
          </span>
        </NoteFooter>
        <ButtonsMap />
      </SizeContainer>
    </Container>
  );
};
export default LossesAndProfits;
